<!--
  File name: SSO.vue
  Program Description:
    - This component handles the redirect after using the SSO login funtionality.
-->
<template>
  <v-progress-linear
    class="here"
    height="100"
    color="purple darken-2"
    indeterminate
  />
</template>

<script>
const Encryption = require('./class/Encryption')
const decryptor = new Encryption()

export default {
  name: 'SSO',
  async created () {
    try {
      const { query } = this.$route
      const { a: encryptedSession, b, err } = query
      let name = 'Login'

      if (encryptedSession) {
        let decrypt = decryptor.decrypt(encryptedSession, b)
        decrypt = JSON.parse(decrypt)
        const resp = await this.$s.loginSSO(decrypt)

        if (resp) {
          name = 'AdminDashboard'
        } else {
          this.$store.dispatch('showAlert', {
            message: 'No session has been passed.',
            type: 'error'
          })
        }
      }

      if (err) {
        const decryptedError = decryptor.decrypt(err, b)
        this.$store.dispatch('showAlert', {
          message: decryptedError,
          type: 'error'
        })
      }

      this.$router.push({
        name
      })
    } catch (err) {
      this.$store.dispatch('showAlert', {
        message: 'SSO login failed.',
        type: 'error'
      })
      this.$router.push({
        name: 'Login'
      })
    }
  }
}
</script>
